import { render, staticRenderFns } from "./ShipmentConfirmDialog.vue?vue&type=template&id=29a28e28&scoped=true&"
import script from "./ShipmentConfirmDialog.vue?vue&type=script&lang=ts&"
export * from "./ShipmentConfirmDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ShipmentConfirmDialog.vue?vue&type=style&index=0&id=29a28e28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a28e28",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VDialog,VIcon,VTextarea})
